import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GET_VIDEO_SUBMISSION_QUERY_KEY } from "./useGetVideoSubmission";

export const useDeleteVideoComment = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ submissionId, commentId }: { submissionId: string; commentId: string }) =>
            client.fetchApi<{ success: boolean; message: string }, {}>({
                endpoint: `video-submissions/${submissionId}/comments/${commentId}`,
                method: 'DELETE',
            }),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: GET_VIDEO_SUBMISSION_QUERY_KEY(variables.submissionId) });
        },
    });
};
